<script lang="ts">
	import type { ComponentProps, Snippet } from 'svelte'

	import Icon from '@isoftdata/svelte-icon'

	interface Props {
		icon: ComponentProps<typeof Icon>['icon'] | ComponentProps<typeof Icon>
		title: string | Snippet
		right?: Snippet
		children?: Snippet
	}

	let { icon, title, right, children }: Props = $props()

	let iconProps = $derived(typeof icon === 'string' ? { icon } : icon)
</script>

<div class="card-header">
	<div class="d-flex flex-wrap justify-content-between">
		<div class="d-inline-block">
			<h4 class="text-ellipsis d-inline">
				<Icon
					{...iconProps}
					fixedWidth
				></Icon>
				{#if typeof title === 'string'}
					{title}
				{:else}
					{@render title()}
				{/if}
			</h4>
		</div>
		<div class="d-flex flex-wrap">
			{@render right?.()}
		</div>
	</div>
	{@render children?.()}
</div>
